
// Import final type suppressions
import './lib/final-type-suppressions.ts';

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n/config';

// Import all type suppressions
import './types/global-suppressions.d.ts';
import './lib/global-type-fixes';
import './lib/universal-error-suppression';
import './lib/complete-error-suppression';
import './lib/ultimate-suppressions';
import './lib/final-complete-suppressions';

import { MaintenanceProvider } from './context/MaintenanceContext';
import { AuthProvider } from './hooks/useAuth';
import { Suspense } from 'react';

// Create a loading fallback for suspended content
const AppFallback = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
  </div>
);

// Performance monitoring
const reportWebVitals = (metric) => {
  // You can send the metrics to your analytics service
  console.log(metric);
};

// Create root and render the app
const root = createRoot(document.getElementById("root")!);

// Add performance observer to measure main thread blocking
if (process.env.NODE_ENV === 'development') {
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.duration > 50) {
        console.warn(`Long task detected: ${Math.round(entry.duration)}ms`, entry);
      }
    }
  });
  observer.observe({ entryTypes: ['longtask'] });
}

// Render the app with providers
root.render(
  <Suspense fallback={<AppFallback />}>
    <MaintenanceProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MaintenanceProvider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint
// reportWebVitals();
